<template>
  <!-- BEGIN: Content-->
  <div class="app-content content ">
    <div class="content-overlay"></div>
    <div class="header-navbar-shadow"></div>
    <div class="content-wrapper">
      <div class="content-header row">
        <div class="content-header-left col-md-9 col-12 mb-2">
          <Breadcrumb
              name="Settlement Configuration"
              bc1="App"
              bc2="Partner"
              bc3="Settlement Configuration"
              :path="listingRoute"
          ></Breadcrumb>
        </div>
        <div class="col-3">
          <div class="d-flex align-items-center justify-content-end">
            <button
                type="button"
                class="btn btn-gradient-danger btn-sm"
                @click="$router.back()"
            >
              <span class="text-nowrap">Back</span>
            </button>
          </div>
        </div>
      </div>
      <div class="content-body">
        <section id="dynamic-form">
          <div class="row">
            <div class="col-md-12 col-12">
              <div class="card">
                  <div class="card-header">
                    <div class="d-flex align-items-center">
                      <nav aria-label="breadcrumb">
                        <ol class="breadcrumb pl-0" >
                          <li class="breadcrumb-item">Partner</li>
                          <li class="breadcrumb-item" v-for="(crumb,index) in currentBreadCrumb" :key="index">{{crumb}}</li>
                        </ol>
                      </nav>
                    </div>
                  </div>
                  <div class="card-header">
                    <h4 class="card-title">Configurations Per Currency</h4>

                    <!-- Add a settlement configuration for a currency that has none yet -->
                    <div v-if="remainingCurrencies.length" class="d-flex align-items-center">
                      <select
                          class="form-control form-control-sm mr-1"
                          style="min-width: 180px"
                          v-model="selectedCurrencyId"
                          :disabled="disableSave"
                      >
                        <option :value="null">Select Currency</option>
                        <option v-for="currency in remainingCurrencies" :key="currency.id" :value="currency.id">
                          {{ currency.code }}
                        </option>
                      </select>
                      <button
                          type="button"
                          class="btn btn-primary btn-sm text-nowrap"
                          :disabled="!selectedCurrencyId || disableSave"
                          @click="addCurrencySection"
                      >
                        Add
                      </button>
                    </div>
                  </div>
                <div class="card-body">

                  <div v-if="!sections.length" class="text-center text-muted p-2">
                    No settlement configuration has been added for this partner yet.
                    <span v-if="remainingCurrencies.length">Select a currency above and press Add.</span>
                  </div>

                  <form class="validate-form mt-2" >
                    <div v-for="(section, sIndex) in sections" :key="section.currencyId" class="mb-2">
                      <div class="d-flex justify-content-between align-items-center bg-light p-2" style="border-radius: 0.5rem;">
                        <h4 class="mb-0">
<!--                          {{ formatSectionName(SECTION) }}-->
                          <span class="badge badge-success ml-1">{{ section.currencyCode }}</span>
                          <span v-if="!section.saved" class="badge badge-warning ml-1">Not Saved</span>

                          <!-- IBAN summary: shown only when the section has an IBAN -->
                          <template v-if="sectionIban(section)">
                            <span class="ml-2 text-dark font-small-3">
                              <span class="text-muted">IBAN:</span> {{ sectionIban(section) }}
                            </span>
                            <span
                                v-if="section.ibanStatus == 1 || section.ibanStatus == 2 || section.ibanVerified"
                                class="badge badge-light-success ml-1"
                            >
                              Verified
                            </span>
                            <span
                                v-if="section.ibanStatus != 2 && (section.ibanStatus == 1 || section.ibanVerified)"
                                class="badge badge-light-danger ml-1"
                            >
                              Not Saved
                            </span>
                            <span
                                v-if="section.ibanStatus == 2"
                                class="badge badge-light-info ml-1"
                            >
                              Saved
                            </span>
                          </template>
                        </h4>
                        <div class="ml-auto d-flex align-items-center">
                          <!-- Section status toggle -->
                          <div class="custom-control custom-control-success custom-switch mr-2">
                            <input
                                type="checkbox"
                                class="custom-control-input"
                                :id="'status-' + section.currencyId"
                                v-model="section.status"
                            />
                            <label class="custom-control-label" :for="'status-' + section.currencyId">
                              {{ section.status ? 'Active' : 'Inactive' }}
                            </label>
                          </div>
                          <div @click="openSettlementSettings(sIndex)" data-toggle="collapse" :data-target="'#collapse-' + section.currencyId" aria-expanded="false" :aria-controls="'collapse-' + section.currencyId">
                            <span class="text-primary" style="cursor: pointer;">
                              <img width="30" height="30" :src="`${publicPath}app-assets/images/icons/settings-gear.svg`" />
                            </span>
                          </div>
                        </div>
                      </div>

                      <div class="row mb-1">
                        <div class="col-12">
                          <div :id="'collapse-' + section.currencyId" class="collapse m-1" :class="{ show: !section.saved }" :aria-labelledby="'heading-' + section.currencyId">
                            <div class="card-body badge-glow border-secondary" style="border-radius: .8rem">
                              <!-- Inactive section: lock all fields -->
                              <fieldset :disabled="!section.status">
                              <div class="row">
                                <div class="col-12 mb-1">
                                  <button
                                      type="button"
                                      class="btn btn-outline-warning btn-sm mr-1"
                                      @click="openClearAllConfirmation(sIndex)"
                                      :disabled="section.loading"
                                  >
                                    Clear All Configurations
                                  </button>
                                  <button
                                      v-if="!section.saved"
                                      type="button"
                                      class="btn btn-outline-danger btn-sm"
                                      @click="removeSection(sIndex)"
                                      :disabled="section.loading"
                                  >
                                    Remove
                                  </button>
                                </div>
                              </div>
                              <div class="row">
                                <!-- IBAN FIELD (SPECIAL CASE) -->
                                <div v-if="ibanFieldOf(section)" class="col-8 mb-2 mt-2">
                                  <div class="form-group">
                                    <label>
                                      IBAN
                                      <!-- BADGES -->
                                      <span>
                                        <span
                                            v-if="section.ibanStatus == 1 || section.ibanStatus == 2 || section.ibanVerified"
                                            class="badge badge-success"
                                        >
                                          Verified
                                        </span>
                                        <span
                                            v-if="section.ibanStatus != 2 && (section.ibanStatus == 1 || section.ibanVerified)"
                                            class="badge badge-danger"
                                            style="margin-left: 0.2rem"
                                        >
                                          Not Saved
                                        </span>
                                        <span
                                            v-if="section.ibanStatus == 2"
                                            class="badge badge-info"
                                            style="margin-left: 0.2rem"
                                        >
                                          Saved
                                        </span>
                                      </span>
                                    </label>

                                    <div class="d-flex">
                                      <input
                                          type="text"
                                          class="form-control mr-1"
                                          v-model="ibanFieldOf(section).value"
                                          placeholder="IBAN"
                                          @input="onIbanInput(section)"
                                          @keydown="onIbanKeydown"
                                      />

                                      <button
                                          v-if="!section.ibanVerified && ibanFieldOf(section).value !== ''"
                                          type="button"
                                          class="btn btn-outline-success btn-sm badge mr-1"
                                          @click="openIbanVerifyModal(sIndex)"
                                      >
                                        Verify
                                      </button>
                                      <button
                                          type="button"
                                          v-if="section.ibanDetailsResponse"
                                          class="btn btn-outline-dark btn-sm badge"
                                          @click="openIbanDetailsModal(sIndex)"
                                      >
                                        Show Details
                                      </button>

                                    </div>
                                  </div>
                                </div>
                                <div v-for="(field, index) in section.fields" :key="index" class="col-md-6">
                                  <div class="form-group">
                                    <label v-if="field.type !== 'checkbox' && field.name !== 'iban' " :for="fieldId(field, section)">{{ field.title }}</label>
                                    <!-- Text Input -->
                                    <input
                                        v-if="(field.type === 'text' || field.type === 'number') && field.name !== 'iban'"
                                        :type="field.type"
                                        class="form-control"
                                        :id="fieldId(field, section)"
                                        v-model="field.value"
                                        :placeholder="field.title"
                                    />

                                    <select
                                        v-if="field.type === 'dropDown'"
                                        class="form-control"
                                        :id="fieldId(field, section)"
                                        v-model="field.value"
                                        :name="fieldId(field, section)"
                                    >
                                      <option :value="null" selected>Select {{ field.title }}</option>
                                      <option v-for="option in field.options" :key="option" :value="option">{{ formatSectionName(option) }}</option>
                                    </select>

                                    <multiselect
                                        v-if="field.type === 'multipleDropDown'"
                                        v-model="section.fields[index]['value']"
                                        :options="field.options"
                                        :multiple="true"
                                        class="shorten-multiselect-option"
                                        :close-on-select="false"
                                        :clear-on-select="false"
                                        :placeholder="'Select ' + field.title"
                                        :name="fieldId(field, section)"
                                        :disabled="!section.status"
                                    ></multiselect>


                                    <!-- Checkbox Input -->
                                    <div class="custom-control custom-switch mb-1" v-if="field.type === 'checkbox'">
                                      <input
                                          type="checkbox"
                                          class="custom-control-input"
                                          :id="fieldId(field, section)"
                                          v-model="section.fields[index].value"
                                      />
                                      <label class="custom-control-label" :for="fieldId(field, section)">{{ field.title }}</label>
                                    </div>

                                    <small v-show="errorBag.has(fieldId(field, section))" class="invalid-feedback">
                                      {{ "*" + errorBag.first(fieldId(field, section)) }}
                                    </small>
                                  </div>
                                </div>
                              </div>
                              </fieldset>

                              <div class="d-flex justify-content-center mt-1">
                                <button
                                    type="button"
                                    class="btn btn-primary d-flex"
                                    @click="saveSection(sIndex)"
                                    :disabled="section.loading || disableSave"
                                >
                                  <Loader :loading="section.loading" :size="size"></Loader>
                                  Save Changes
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
    <CustomConfirmationModal :show="showClearAllConfirmationModal" @confirm="clearAllConfigParameters" message="Are you sure to clear all configurations?"
                             title="Please Confirm"
                             @hide="showClearAllConfirmationModal = false"></CustomConfirmationModal>
    <VerifyIbanModal
        :show="showIbanModal"
        :iban="activeIbanField?.value"
        :response="activeSection?.ibanResponse"
        :loading="ibanLoading"
        :error="ibanError"
        @close="showIbanModal = false"
        @verify="handleVerifyIban"
        @save="handleSaveIban"
        @clear-error="ibanError = null"
    />


    <IbanDetailsModal
        :show="showIbanDetailsModal"
        :data="activeSection?.ibanDetailsResponse"
        @close="showIbanDetailsModal = false"
        :loading="ibanLoading"
        @save="handleSaveIban"
    />


  </div>
  <!-- END: Content-->
</template>

<script>
import CustomConfirmationModal from "@/pages/dashboard/schema/customConfirmationModal.vue";
import VerifyIbanModal from "@/pages/dashboard/merchant/stores/SettlementVerifyIbanModal.vue";
import IbanDetailsModal from "@/pages/dashboard/merchant/stores/SettlementIbanDetailsModal.vue";

// Key of the settings block inside the field-definition payload and inside each saved config
const SECTION = 'settlementConfigurations'
// Key on the partner listing row that holds the per-currency saved settlement configurations
const SAVED_CONFIG_KEY = 'settlement_configurations'
// "type" sent to the settlement-configuration APIs for a partner
const PARTNER_TYPE = 3
// iban_status: 1 = verified but not saved, 2 = verified and saved

export default {
  components: {
    IbanDetailsModal,
    VerifyIbanModal,
    CustomConfirmationModal

  },
  mounted() {
    this.setBreadCrumb()
    this.loadPageData()
  },
  computed: {
    partnerData() {
      return this.$store.getters.getByKey("partnerSettlementConfiguration") || null
    },
    partnerRow() {
      return this.partnerData?.row || null
    },
    listingRoute() {
      return 'partners'
    },
    remainingCurrencies() {
      const used = new Set(this.sections.map(section => String(section.currencyId)))
      return this.currencies.filter(currency => !used.has(String(currency.id)))
    },
    activeSection() {
      if (this.activeSectionIndex === null) return null
      return this.sections[this.activeSectionIndex] || null
    },
    activeIbanField() {
      return this.activeSection ? this.ibanFieldOf(this.activeSection) : null
    },
  },
  data() {
    return {
      SECTION,
      currentBreadCrumb:[],
      currencies: [],
      fieldTemplate: [],
      sections: [],
      selectedCurrencyId: null,
      activeSectionIndex: null,
      size: "10px",
      showClearAllConfirmationModal:false,
      disableSave:false,
      showIbanModal: false,
      ibanLoading: false,
      showIbanDetailsModal: false,
      ibanError: null,
    };
  },

  methods: {
    setBreadCrumb(){
      const partnerName = this.partnerRow?.first_name
      if(partnerName){
        this.currentBreadCrumb.push(partnerName)
      }

      if(this.partnerRow?.business_name){
        this.currentBreadCrumb.push(this.partnerRow.business_name)
      }
    },

    // ---------- Loading ----------
    loadPageData() {
      Promise.all([this.getConfigurationSettings(), this.getCurrencies()]).then(() => {
        this.buildSectionsFromPartner()
      })
    },
    getConfigurationSettings(){
      return this.makeRequest("post", "v1/get-charges-types-data", {channelSettings: 1}, {}, false,true,[205]).then(
          callResponse => {
            if (!callResponse.error) {
              let code = callResponse.response.data.code;
              if (code == 200) {
                let data = callResponse.response.data.data;
                this.processResponseData(JSON.parse(data.channelSettings));
              }
            }
          }
      );
    },
    processResponseData(data) {
      if (!data[SECTION]?.length) {
        this.fieldTemplate = []
        this.disableSave = true
        return
      }

      this.fieldTemplate = data[SECTION]
    },
    getCurrencies() {
      return this.makeRequest("post", "v1/get-currency", {flag: "active"}, {}, false).then(
          callResponse => {
            if (!callResponse.error) {
              let code = callResponse.response.data.code;
              if (code == 200) {
                this.currencies = callResponse.response.data.data || [];
              }
            }
          }
      );
    },

    // ---------- Sections ----------
    buildSectionsFromPartner() {
      const savedConfigs = this.extractSavedConfigs(this.partnerRow)

      this.sections = savedConfigs
          .filter(config => config.currencyId !== undefined && config.currencyId !== null)
          .map(config => this.createSection(config.currencyId, config))
    },
    // Normalises the per-currency configs carried on the partner listing row.
    // Tolerates: JSON string, array of configs, or an object keyed by currencyId.
    extractSavedConfigs(row) {
      if (!row) return []

      let list = row[SAVED_CONFIG_KEY]
      if (typeof list === 'string') {
        try { list = JSON.parse(list) } catch (e) { list = null }
      }
      if (!list) return []
      if (!Array.isArray(list)) {
        list = Object.keys(list).map(key => ({ currencyId: key, ...list[key] }))
      }

      return list.map(item => {
        let settings = item.settings
        if (typeof settings === 'string') {
          try { settings = JSON.parse(settings) } catch (e) { settings = null }
        }
        if (settings && settings[SECTION]) {
          settings = settings[SECTION]
        }

        return {
          currencyId: item.currency_id ?? item.currencyId ?? item.currency?.id,
          currencyCode: item.currency?.code ?? item.currencyCode ?? item.currency_code,
          settings: settings || {},
          iban: item.iban ?? '',
          ibanStatus: item.iban_status ?? null,
          status: item.status,
        }
      })
    },
    createSection(currencyId, saved = null) {
      const currency = this.currencies.find(c => String(c.id) == String(currencyId))

      const fields = this.fieldTemplate.map(field => {
        let value = field.type === 'checkbox' ? false :
            field.type === 'multipleDropDown' ? (field.value || []) :
                field.value || ''

        if (saved) {
          if (field.name === 'iban') {
            // IBAN is delivered as a separate param, not inside settings
            value = saved.iban ?? ''
          } else if (saved.settings[field.name] !== undefined) {
            value = saved.settings[field.name]
          }
        }

        return { ...field, value }
      })

      return {
        currencyId,
        currencyCode: currency?.code || saved?.currencyCode || ('#' + currencyId),
        fields,
        status: saved && saved.status !== undefined && saved.status !== null ? saved.status == 1 : true,
        saved: !!saved,
        loading: false,
        ibanVerified: !!(saved && saved.iban),
        ibanStatus: saved?.ibanStatus ?? null,
        ibanResponse: null,
        ibanDetailsResponse: null,
      }
    },
    addCurrencySection() {
      if (!this.selectedCurrencyId) return

      const alreadyAdded = this.sections.some(s => String(s.currencyId) == String(this.selectedCurrencyId))
      if (alreadyAdded) return

      this.sections.push(this.createSection(this.selectedCurrencyId))
      this.selectedCurrencyId = null
    },
    removeSection(index) {
      const section = this.sections[index]
      if (!section || section.saved) return

      this.sections.splice(index, 1)
      if (this.activeSectionIndex === index) {
        this.activeSectionIndex = null
      }
    },
    ibanFieldOf(section) {
      return section.fields.find(f => f.name === 'iban')
    },
    sectionIban(section) {
      const value = this.ibanFieldOf(section)?.value
      return typeof value === 'string' && value.trim() !== '' ? value : null
    },
    fieldId(field, section) {
      return field.name + '-' + section.currencyId
    },
    openClearAllConfirmation(index) {
      this.activeSectionIndex = index
      this.showClearAllConfirmationModal = true
    },
    clearAllConfigParameters() {
      const section = this.activeSection
      this.showClearAllConfirmationModal = false
      if (!section) return

      section.fields = section.fields.map(field => ({
        ...field,
        value: field.type === 'checkbox' ? false : ''
      }));

      this.onIbanInput(section)
    },

    // ---------- Save ----------
    buildSavePayload(section) {
      let rawData = {};
      let iban = '';

      section.fields.forEach(field => {
        // IBAN goes out as its own param, not inside settings
        if(field.name === 'iban'){
          iban = field.value ?? '';
          return
        }

        if(field.type === 'checkbox'){
          if(field.value != true){
            return
          }
        }

        if(field.value == '' || field.value == null){
          return;
        }

        rawData[field.name] = field.value;
      });

      return {
        type: PARTNER_TYPE,
        typeId: this.$route.params.partnerId,
        currencyId: section.currencyId,
        settings: JSON.stringify(rawData),
        iban: iban,
        status: section.status ? 1 : 0
      }
    },
    saveSection(index) {
      const section = this.sections[index]
      if (!section) return

      this.$validator.validateAll().then(valid => {
        if (!valid) return

        section.loading = true;
        const data = this.buildSavePayload(section)

        this.makeRequest("post", "v1/update-settlement-configuration", data).then(
            callResponse => {
              section.loading = false
              if (callResponse.error) return

              section.saved = true
              this.syncSavedConfigToPartner(section, data)
            }
        );
      });
    },
    // Keep the partner listing row in sync so this page shows the config again
    // if the user navigates back before the listing is refreshed from the API.
    syncSavedConfigToPartner(section, payload) {
      if (!this.partnerData || !this.partnerRow) return

      let list = this.partnerRow[SAVED_CONFIG_KEY]
      if (typeof list === 'string') {
        try { list = JSON.parse(list) } catch (e) { list = null }
      }
      list = Array.isArray(list) ? [...list] : []

      // Mirror the shape returned by get-partners (settlement_configurations[])
      const entry = {
        type: PARTNER_TYPE,
        type_id: this.$route.params.partnerId,
        currency_id: section.currencyId,
        currency: { id: section.currencyId, code: section.currencyCode },
        settings: { [SECTION]: JSON.parse(payload.settings) },
        iban: payload.iban,
        iban_status: section.ibanStatus,
        status: payload.status,
      }

      const existingIndex = list.findIndex(item =>
          String(item.currency_id ?? item.currencyId ?? item.currency?.id) == String(section.currencyId)
      )
      if (existingIndex >= 0) {
        list.splice(existingIndex, 1, { ...list[existingIndex], ...entry })
      } else {
        list.push(entry)
      }

      this.$store.dispatch("set", {
        ...this.partnerData,
        row: {
          ...this.partnerRow,
          [SAVED_CONFIG_KEY]: list
        }
      });
    },

    formatSectionName(name) {
      return name
          .replace(/([A-Z])/g, " $1") // Add space before uppercase letters
          .replace(/_/g, " ") // Replace underscores with spaces
          .replace(/\b\w/g, c => c.toUpperCase()) // Capitalize first letter of each word
          .trim(); // Remove leading/trailing spaces
    },

    // ---------- IBAN ----------
    openIbanVerifyModal(index) {
      this.activeSectionIndex = index
      this.ibanError = null
      if (this.activeSection) {
        this.activeSection.ibanResponse = null
      }
      this.showIbanModal = true
    },
    openIbanDetailsModal(index) {
      this.activeSectionIndex = index
      this.showIbanDetailsModal = true
    },
    handleVerifyIban(payload) {
      const section = this.activeSection
      if (!section) return

      this.ibanLoading = true;
      this.ibanError = null

      this.makeRequest("post", "v1/verify-settlement-iban", {
        type: PARTNER_TYPE,
        typeId: this.$route.params.partnerId,
        currencyId: section.currencyId,
        iban: payload.iban,
        save: 0
      }).then(res => {
        this.ibanLoading = false;
        let code = res.response.data.code;
        if (!res.error && code == 200) {
          section.ibanResponse = res.response.data.data;
          section.ibanVerified = true;
          section.ibanStatus = section.ibanResponse.iban_status;
        }else{
          if (code == 400) {
            this.ibanError =
                res.response?.data?.message ||
                "Unable to verify IBAN. Please try again."
          }
          section.ibanVerified = false;
          section.ibanStatus = null;
        }
      });
    },

    handleSaveIban(payload) {
      const section = this.activeSection
      if (!section) return

      this.ibanLoading = true;

      const requestData = {
        type: PARTNER_TYPE,
        typeId: this.$route.params.partnerId,
        currencyId: section.currencyId,
        iban: payload.iban,
        save: payload.save ?? 1
      };

      if (payload.accountTitle) {
        requestData.accountTitle = payload.accountTitle;
      }

      this.makeRequest("post", "v1/verify-settlement-iban", requestData).then(res => {
        this.ibanLoading = false;
        let code = res.response.data.code;
        if (!res.error && code == 200) {
          section.ibanResponse = res.response.data.data;
          this.showIbanModal = false;
          this.showIbanDetailsModal = false;
          section.ibanVerified = true;
          section.ibanStatus = 2;

          if(payload.fromDetails){
            section.ibanDetailsResponse = {...section.ibanDetailsResponse, iban_status: 2};
          }

          this.openSettlementSettings(this.activeSectionIndex)
        }
      });
    },
    onIbanInput(section) {
      const ibanField = this.ibanFieldOf(section)
      // Remove spaces from IBAN value
      if (ibanField && typeof ibanField.value === 'string') {
        ibanField.value = ibanField.value.replace(/\s/g, '');
      }
      section.ibanVerified = false
      section.ibanResponse = null
      section.ibanDetailsResponse = null
      section.ibanStatus = null;
    },
    onIbanKeydown(event) {
      // Prevent space key
      if (event.key === ' ') {
        event.preventDefault();
      }
    },
    openSettlementSettings(index) {
      const section = this.sections[index]
      if (!section) return

      this.activeSectionIndex = index

      const ibanField = this.ibanFieldOf(section)
      if (!ibanField?.value) {
        return
      }

      this.ibanLoading = true
      section.ibanDetailsResponse = null

      this.makeRequest("post", "v1/get-settlement-configuration", {
        type: PARTNER_TYPE,
        typeId: this.$route.params.partnerId,
        currencyId: section.currencyId
      }, {}, false).then(res => {
        this.ibanLoading = false

        if (res.error) return

        const data = res.response.data.data

        // No configuration, or one without a verified IBAN, for this currency yet
        if (!data || !data.iban || !data.iban_details) {
          section.ibanVerified = false;
          section.ibanStatus = null;
          return
        }

        section.ibanDetailsResponse = data
        section.ibanStatus = data.iban_status;
      })
    },
  }
};
</script>
